import { Box } from '@/components/Box/Box';
import { ReelAnimateValue } from './ReelAnimateValue';
import { formatSecondsToMinutes } from '@/helpers/dateHelpers/dateHelpers';

type ReelAnimateTimeType = {
  seconds: number;
};

export const ReelAnimateTime = ({ seconds: secondsValue }: ReelAnimateTimeType) => {
  const [minutes, seconds] = formatSecondsToMinutes(secondsValue).split(':');

  const [firstDigitMinutes, lastDigitMinutes] = minutes.split('');
  const [firstDigitSeconds, lastDigitSeconds] = seconds.split('');

  return (
    <Box display='flex'>
      <ReelAnimateValue value={firstDigitMinutes} />
      <ReelAnimateValue value={lastDigitMinutes} />
      :
      <ReelAnimateValue value={firstDigitSeconds} />
      <ReelAnimateValue value={lastDigitSeconds} />
    </Box>
  );
};
